import { RugbyUnionEventDetailId } from '@collector/sportsapi-client-legacy'

import { EventInfoControls } from '../../../configuration'

export const eventInfoControls: EventInfoControls = [
  {
    control: 'Referee',
  },
  {
    grid: {
      cols: '2',
      controls: [
        {
          eventDetailId: RugbyUnionEventDetailId.WeatherConditions,
          label: 'Weather cond.',
        },
        {
          eventDetailId: RugbyUnionEventDetailId.PitchConditions,
          label: 'Pitch cond.',
        },
      ],
    },
  },
  {
    grid: {
      cols: '3',
      controls: [
        {
          eventDetailId: RugbyUnionEventDetailId.PeriodLength,
          postfix: 'min',
        },
        {
          eventDetailId: RugbyUnionEventDetailId.ExtraPeriodLength,
          label: 'Extra period',
          postfix: 'min',
        },
        {
          eventDetailId: RugbyUnionEventDetailId.HasLineups,
        },
        'empty',
        'empty',
        'TeamColorsSwitch',
      ],
    },
  },
]
